(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  function playHeroVideos() {
    document.querySelectorAll('.hero__media-wrapper video').forEach(function(v) {
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.muted = true;
      if (v.paused) {
        v.play().catch(function(){});
      }
    });
  }

  document.addEventListener('DOMContentLoaded', playHeroVideos);
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) playHeroVideos();
  });
  window.addEventListener('focus', playHeroVideos);
  window.addEventListener('pageshow', playHeroVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
